import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import axios from "axios";
import _ from "lodash";
import React, { useCallback, useMemo, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import { textFormatter } from "../../fomatters/TextFormatter";
import Crud from "../Crud";
import InputSelect from "../InputSelect";
import InputSelectGameParent from "../InputSelectGameParent";
import SubGroup from "../SubGroup";
import WagerDetails from "./WagerDetails";

function removeSecondsAndMilliseconds(date) {
  // Extract the components excluding seconds and milliseconds
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  // Construct the formatted datetime string
  const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

  return formattedDateTime;
}
const startDate = new Date();
startDate.setHours(0, -startDate.getTimezoneOffset(), 0);

const endDate = new Date();
endDate.setDate(endDate.getDate() + 6);
endDate.setHours(0, -endDate.getTimezoneOffset(), 0);

const startDateValue = removeSecondsAndMilliseconds(startDate);
const endDateValue = removeSecondsAndMilliseconds(endDate);

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function DeleteWagers() {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  /**
   * DATES
   */
  const [usePlacedDate, setUsePlacedDate] = useState(false);
  const handleUsePlacedDateChange = useCallback(
    (event) => setUsePlacedDate(event.target.checked),
    []
  );

  const [placedDateFrom, setPlacedDateFrom] = useState(startDateValue);
  const handlePlacedDateFromChange = useCallback(
    (event) => setPlacedDateFrom(event.target.value),
    []
  );

  const [placedDateTo, setPlacedDateTo] = useState(endDateValue);
  const handlePlacedDateToChange = useCallback(
    (event) => setPlacedDateTo(event.target.value),
    []
  );

  /**
   * Game
   */
  const [idGame, setIdGame] = useState(-1);
  const onIdGameChange = useCallback((p) => setIdGame(Number(p)), []);

  const [useGame, setUseGame] = useState(false);
  const handleUseGameChange = useCallback((event) => {
    setUseGame(event.target.checked);
    setIdGame(-1);
  }, []);

  const [idPlayer, setIdPlayer] = useState(-1);
  const requestUser = useCallback(
    (currentPlayer) => {
      const url = `${process.env.REACT_APP_API2_URL}/Player/Player_GetInfo?Player=${currentPlayer}&IdUser=${userInfo.userId}`;
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setIdPlayer(data?.idPlayer ?? -1);
        });
    },
    [userInfo]
  );

  /**
   * WAGER FILTERS
   */
  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );
  const onPlayerBlur = useCallback(() => {
    if (player) requestUser(player);
    else setIdPlayer(-1);
  }, [player, requestUser]);

  const [idAgent, setIdAgent] = useState(-1);
  const onIdAgentChange = useCallback((p) => setIdAgent(Number(p)), []);
  const { values: agents } = useDataFormatterHook({
    addEmpty: true,
    value: "idAgent",
    text: "agent",
    path: `/Agent/Agent_GetList2Result?idUser=${userInfo.userId}`,
    emptyValue: -1,
  });

  const [idSport, setIdSport] = useState("CBB  ");
  const onSportChanged = useCallback((p) => setIdSport(p), []);
  const { values: sports } = useDataFormatterHook({
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  const [, setVoidReason] = useState("");
  const onVoidReasonChanged = useCallback((v) => setVoidReason(v), []);
  const { values: voidReasons } = useDataFormatterHook({
    addEmpty: true,
    value: "idVoidReason",
    text: "voidReason",
    path: `/Wager/VoidReason_GetList`,
  });

  /**
   * ROW SELECTION
   */
  const [selectedWager, setSelectedWager] = useState({});
  const onRowClick = useCallback((row) => {
    setSelectedWager(row);
  }, []);

  return (
    <div className="flex flex-col w-full gap-4 p-4 h-max">
      <SubGroup title="Search" className="grid grid-cols-3 gap-4 p-4">
        <div className="flex flex-col gap-4">
          <SubGroup
            title={
              <FormControlLabel
                control={
                  <Checkbox
                    checked={usePlacedDate}
                    onChange={handleUsePlacedDateChange}
                    color="primary"
                    size="small"
                  />
                }
                label="Placed Date"
              />
            }
            className="items-center p-2 pt-4"
            classNameSpan="-top-5 w-max"
          >
            <TextField
              disabled={!usePlacedDate}
              required
              variant="outlined"
              label="From"
              type="datetime-local"
              size="small"
              value={placedDateFrom}
              onChange={handlePlacedDateFromChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              disabled={!usePlacedDate}
              required
              variant="outlined"
              label="To"
              type="datetime-local"
              size="small"
              value={placedDateTo}
              onChange={handlePlacedDateToChange}
              InputLabelProps={{ shrink: true }}
            />
          </SubGroup>
        </div>
        <div className="flex flex-col gap-4">
          <SubGroup
            title={
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useGame}
                    onChange={handleUseGameChange}
                    color="primary"
                    size="small"
                  />
                }
                label="Game"
              />
            }
            className="items-center p-2 pt-4"
            classNameSpan="-top-5 w-max"
          >
            <InputSelect
              disabled={!useGame}
              variant="outlined"
              size="small"
              label="Sport"
              name="name"
              data={sports}
              placeholder="DataFormatter"
              setSelectValue={onSportChanged}
              startValue={idSport}
            />
            <InputSelectGameParent
              disabled={!useGame}
              idSport={idSport}
              setSelectValue={onIdGameChange}
            />
          </SubGroup>
        </div>
        <div className="flex flex-col gap-4">
          <SubGroup className="items-center p-2 pt-4">
            <TextField
              required
              variant="outlined"
              label="Player"
              type="text"
              size="small"
              value={player}
              onBlur={onPlayerBlur}
              onChange={onPlayerChange}
              InputLabelProps={{ shrink: true }}
            />

            <InputSelect
              variant="outlined"
              size="small"
              label="Agent"
              name="name"
              data={agents}
              placeholder="DataFormatter"
              startValue={idAgent}
              setSelectValue={onIdAgentChange}
            />
          </SubGroup>
        </div>
        <InputSelect
          className="col-span-3"
          variant="outlined"
          size="small"
          label="Delete Reason"
          name="name"
          data={voidReasons}
          placeholder="DataFormatter"
          startValue={""}
          setSelectValue={onVoidReasonChanged}
        />
      </SubGroup>
      <Crud
        title="Delete Wagers"
        searchButton
        onRowClick={onRowClick}
        getUrl={() => "/Wager/WagerHeader_GetDeleteWagersList"}
        getParams={() => ({
          UsePlacedDate: usePlacedDate,
          PlacedDateFrom: placedDateFrom,
          PlacedDateTo: placedDateTo,
          IdPlayer: idPlayer,
          IdAgent: idAgent,
          IdGame: idGame,
        })}
        getPreProcess={(data) => Object.values(_.groupBy(data, "ticketNumber"))}
        getProcess={(data) =>
          data.map((group) =>
            group.reduce(
              (acc, curr, index) => ({
                ...curr,
                descriptionTicket:
                  index === 0
                    ? [curr.headerDescription, curr.detailDescription]
                    : [...acc.descriptionTicket, curr.detailDescription],
              }),
              {}
            )
          )
        }
        deleteUrl={() => ""}
      >
        <TableHeaderColumn dataSort dataField="ticketNumber" isKey>
          Ticket #
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneLine">
          Phone
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="ip" width="150">
          IP
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="gameDateTime"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          Game Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="idSport"></TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="descriptionTicket"
          width="250"
          dataFormat={textFormatter}
        >
          Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="riskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
      </Crud>
      <WagerDetails
        WagerId={selectedWager.ticketNumber}
        Graded={selectedWager.graded}
        Open={selectedWager}
        onClose={() => setSelectedWager({})}
      />
    </div>
  );
}

export default DeleteWagers;
